import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";

type Tables = any;

export default function Bit8Tables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"8 Bit"} />
        <h2 className="h2 p-4 pb-0 flex items-center gap-1 mb-6">
          8 Bit Grand Prize
        </h2>
        <LootGrid data={tables} />
      </div>
    </AdLayout>
  );
}

